
import { computed, defineComponent, reactive } from 'vue'
import { useStore } from 'vuex'
import RedpackInfoSymbol, { IRedPackBasicInfo } from './RedpackInfoSymbol.vue'

export default defineComponent({
  components: { RedpackInfoSymbol },
  props: {
    redPackId: {
      type: String,
      required: true
    },

    chainId: {
      type: [Number, String],
      required: true
    },

    info: {
      type: Object
    }
  },

  emits: ['modelValue:info'],

  setup (props, { emit }) {
    const store = useStore()

    const redPackBasicInfo = computed(() => {
      return store.state.info.basic
    })

    return {
      redPackBasicInfo
    }
  }
})
